(function (ns, originalFetch) {
  ns.fetch = function(resource, config) {
    let url = typeof resource === 'string' ? new URL(resource, window.location.origin) : new URL(resource.url, window.location.origin);

    if (url.href.includes(`${window.location.origin}/cart`)) {
      url.searchParams.set('t', Date.now());
      resource = url.toString();
    }

    const response = originalFetch.call(this, resource, config);
    return response;
  };
})(window, window.fetch);


function handleCartEvents(event) {
    console.log(event.type, event.detail); 

    setTimeout(() => {
        const button = document.querySelector(".btn-continue");
        if (button && !button.dataset.eventAdded) {
            button.addEventListener("click", () => {
                window.location.href = "https://blop.today/products/blop";
            });
            button.dataset.eventAdded = "true"; 
        }
    }, 500); // Trì hoãn 500ms (có thể điều chỉnh)
}

window.addEventListener('OpusCartChange', handleCartEvents);
window.addEventListener('OpusOpenCartState', handleCartEvents);
